import { ALLSTATEMAPMASTER } from "../../actions/portal/";

export default function(state = null, action) {
  switch (action.type) {
    case ALLSTATEMAPMASTER:
      return action.payload;
    default:
  }

  return state;
}
